import { Avatar, AvatarFallback } from '@/components/ui/avatar';

const testimonials = [
  {
    quote: 'TenderAI cut our bid prep from three weeks to four days. The compliance matrix alone took a full week.',
    name: 'Rebecca Thornton',
    title: 'Director of Bids & Proposals',
    company: 'Nexus Infrastructure',
    initials: 'RT',
    color: 'bg-primary/15 text-primary',
    rotation: 'testimonial-rotate-1',
  },
  {
    quote: 'The risk flagging caught a liability clause we missed in three separate manual reviews. That single catch saved us from six-figure exposure.',
    name: 'David Park',
    title: 'Procurement Manager',
    company: 'UrbanTech Solutions',
    initials: 'DP',
    color: 'bg-accent/15 text-accent',
    rotation: 'testimonial-rotate-2',
  },
  {
    quote: 'We went from bidding blind to data-driven decisions. Our win rate improved by 34% in six months.',
    name: 'Amara Osei',
    title: 'Head of Strategy',
    company: 'Compass Consulting',
    initials: 'AO',
    color: 'bg-emerald-100 text-emerald-700',
    rotation: 'testimonial-rotate-3',
  },
  {
    quote: 'I use TenderAI for every bid now. It surfaces requirements I would have missed and structures our responses beautifully.',
    name: 'James Whitfield',
    title: 'Senior Bid Writer',
    company: 'Meridian Group',
    initials: 'JW',
    color: 'bg-blue-100 text-blue-700',
    rotation: 'testimonial-rotate-4',
  },
  {
    quote: <>The draft generation is incredible. What used<br className="md:hidden" /> to take days of writing now takes hours of refinement.</>,
    name: 'Sophie Chen',
    title: 'Operations Director',
    company: 'Pacific Consulting',
    initials: 'SC',
    color: 'bg-purple-100 text-purple-700',
    rotation: 'testimonial-rotate-5',
  },
  {
    quote: <>The AI pulls out exactly the right compliance requirements and maps them to our evidence.<br className="hidden md:inline" /> An absolute game changer.</>,
    name: 'Chris Martin',
    title: 'Compliance Lead',
    company: 'Atlas Projects',
    initials: 'CM',
    color: 'bg-rose-100 text-rose-600',
    rotation: 'testimonial-rotate-6',
  },
];

export default function Testimonials() {
  return (
    <section
      id="testimonials"
      data-testid="testimonials-section"
      className="section-spacing scroll-mt-24"
    >
      <div className="section-container">
        {/* Centered heading */}
        <div className="text-center max-w-2xl mx-auto mb-12 sm:mb-16">
          <p data-animate className="kicker mb-4">User stories</p>
          <h2
            data-animate
            style={{ transitionDelay: '70ms' }}
            className="font-display text-2xl sm:text-3xl lg:text-[2.5rem] tracking-[-0.01em] leading-[1] lg:leading-[1.1] mb-4"
          >
            Made for
            bid teams
          </h2>
          <p
            data-animate
            style={{ transitionDelay: '140ms' }}
            className="text-sm sm:text-base text-muted-foreground leading-relaxed"
          >
            Built for procurement professionals, bid writers, and compliance teams who<br className="hidden md:inline" /> aim to win more and waste less.
          </p>
        </div>

        {/* Masonry cards */}
        <div className="columns-1 sm:columns-2 lg:columns-3 gap-5">
          {testimonials.map((t, i) => (
            <div
              key={t.name}
              data-testid={`testimonial-card-${i}`}
              data-animate
              style={{ transitionDelay: `${i * 70}ms` }}
              className={`mb-5 break-inside-avoid rounded-2xl border border-border/70 bg-card p-6 shadow-card ${t.rotation} hover:shadow-card-hover bento-card`}
            >
              <p className="text-sm text-foreground/90 leading-relaxed mb-4">
                "{t.quote}"
              </p>
              <div className="flex items-center gap-3">
                <Avatar className="w-8 h-8">
                  <AvatarFallback className={`text-xs font-medium ${t.color}`}>
                    {t.initials}
                  </AvatarFallback>
                </Avatar>
                <div>
                  <p className="text-xs font-medium text-foreground">{t.name}</p>
                  <p className="text-[10px] text-muted-foreground">{t.title}, {t.company}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
